import React, { useEffect, useState } from "react";
import axios from "axios";

import { getUser, getIdToken } from "../../../../utils/storage";
import { getClientSettings } from "../../../../services/dashboard-api";

const Cost = (props) => {
  const { request } = props;

  console.log("request", request);

  const [creditsPerRespondent_interact, setCreditsPerRespondent_interact] =
    useState(0);

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_client_settings`,
  //       {
  //         uid: getUser().uid,
  //         idToken: getIdToken(),
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then(({ data }) => {
  //       setCreditsPerRespondent_interact(
  //         data?.clientSettings?.creditsPerRespondent_interact
  //       );
  //     })
  //     .catch((error) => {
  //       console.log("Error getting client settings:", error);
  //     });
  // }, []);

  useEffect(() => {
    const getAllClientSettings = async () => {
      try {
        // const { data } = await getClientSettings();
        // const clientSettings = data?.clientSettings;
        // const rate = Number(clientSettings?.exchangeRate_NGNperUSD);
        // setExchangeRate_NGNPerUSD(parseFloat(rate));

        const { data } = await getClientSettings();
        setCreditsPerRespondent_interact(data?.creditsPerRespondent_interact);
        console.log("raw data", data);
      } catch (error) {
        console.log("Error obtaining client settings", error.message);
      }
    };
    getAllClientSettings();
  }, []);

  if (!request) return "";

  console.log("request", request);

  return (
    <div className="call-out push-up">
      <div className="small-text">
        <strong>{request.numberOfRespondents} </strong>respondents
      </div>
      <div className="divider move-down purple"></div>
      <div className="row spaced items-center">
        <div className="small-text uppercase">Total Cost</div>
        <div className="primary bold">
          {(request.np * creditsPerRespondent_interact).toLocaleString()} VC
        </div>
      </div>
    </div>
  );
};

export default Cost;
